










































import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util'
import PageRequest from '@/store/entities/page-request'
import { Component,Watch } from 'vue-property-decorator'
import { EventBus } from '@/lib/eventbus';
import Url from "@/lib/url";
class  PageMediaRequest extends PageRequest{
    keyword:string;
    type:string;
}
@Component({
})
export default class MediaManager extends AbpBase {
    pagerequest:PageMediaRequest=new PageMediaRequest();
    cacheKey:number = +new Date();
    ftpIsActive:boolean = Util.abp.setting.getBoolean("App.FtpIsActive");
    ftpServerMediaPath:string = Util.abp.setting.get('App.ServerMediaPath');
    action:string = Url + "api/MediaManager/CreateMediaItem"
    @Watch('editModalShow')
    onCropp(val: string, oldVal: string) {
       //to do reload images
    }
    get list(){
        return this.$store.state.medialist.list;
    }
    get loading(){
        return this.$store.state.medialist.loading;
    }
    get pageSize(){
        return this.$store.state.medialist.pageSize;
    }
    get totalCount(){
        return this.$store.state.medialist.totalCount;
    }
    get currentPage(){
        return this.$store.state.medialist.currentPage;
    }
    async changeIsActive(status) {
        await this.$store.dispatch({
        type: "options/isFtpActive",
        data: { active: status },
        });
        this.ftpIsActive = status;
        Util.abp.setting.set("App.FtpIsActive",status.toString())
    }
    fileUploadSuccess(){
        this.getpage();
    }
    fileUploadProgress(event, file, fileList){
        this.$store.commit('medialist/setLoading',true);
        event.percent = 0;
        file.percentage = 0;
    }
    pageChange(page:number){
        this.$store.commit('medialist/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('medialist/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){      
        this.$store.commit('medialist/setPageSize',this.pageSize);    
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        this.pagerequest.type ="";
        //filters            
        await this.$store.dispatch({
            type:'medialist/getAll',
            data:this.pagerequest
        })
    }
    async editImage(row){     
        const mediaId = row.id;
        this.$router.push({ name: 'editmedia', params: { mediaId }})
    }
    mounted(){
        EventBus.$on("sendProgress", (num) => {
            if(this.$refs.files == undefined){
                return false;
            }
            //@ts-ignore
            if(this.$refs.files.fileList != undefined){
                //@ts-ignore
                var file = this.$refs.files.fileList.filter( file => file.name == num.fileName)[0]
                file.percentage = num.progressVal
            }
        });
        setInterval(() => {
            if(this.$refs.files == undefined){
                return false;
            }
            //@ts-ignore
            if(this.$refs.files.fileList != undefined)
            {
                //@ts-ignore
                var filesToClose = this.$refs.files.fileList.filter( file => file.status == "finished");
                if(filesToClose != undefined)
                {
                    filesToClose.forEach(element => {
                        //@ts-ignore
                        this.$refs.files.fileList.splice(this.$refs.files.fileList.findIndex(file => file.fileName == element.fileName),1);
                    });
                }
            }
        }, 2000)
    }  
    async search(){
        this.$store.commit('medialist/setCurrentPage',1);
        this.getpage();
    }
    async created(){
        this.$store.commit('medialist/setCurrentPage',1);
        this.$store.commit('medialist/setPageSize',20); 
        this.getpage();
    }
    columns=[
    {            
        title:this.L('File'),
        width:120,
        render:(h:any,params:any)=>{
            let imgUrl = Util.getImgFromMediaType(params.row.mediaType,params.row.fileWebThumbnail);
            let attrs = {"src":imgUrl + '?rnd=' + this.cacheKey,"padding-top":"4px","class":"table-img"};
            return h('div',{
                "class":"table-img-cont"
                ,on:{
                        click:async ()=>{
                            this.editImage(params.row);
                        }
                    }
                },[h('img',{attrs})]);
        }
    },
    {
        title:this.L('FileName'),
        key:'fileName'
    },
    {
        title:this.L('FileWebPath'),
        key:'fileWebPath'
    },
    {
        title:this.L('ResponsibleUserName'),
        key:'responsibleUserName'
    },{
        title:this.L('Description'),
        key:'description'
    },{
        title:this.L('CustomName'),
        key:'customName'
    }
    ,{
        title:this.L('Actions'),
        key:'Actions',
        width:150,
        render:(h:any,params:any)=>{
            return h('div',[   
                h('Button',{
                    props:{
                        type:'primary',
                        icon:'md-create',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            this.editImage(params.row)
                        }
                    }
                },),                
                h('Button',{
                    props:{
                        type:'error',
                        icon:'md-trash',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Info'),
                                    content:this.L('DeleteMediaConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        this.$store.commit('medialist/setLoading',true);
                                        await this.$store.dispatch({
                                            type:'medialist/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },)
            ])
        }
    }]
    headers ={
        "Abp.TenantId":window.abp.multiTenancy.getTenantIdCookie(),
        "Authorization":"Bearer "+window.abp.auth.getToken()
    }
};
